// src/modules/LiberacoesFinanceiras/PIX/PixConfirmationPopup.jsx
import React, { useState } from 'react';
import './PixConfirmationPopup.css';
import { authorizePayment } from '../services/pixPaymentService';

const PixConfirmationPopup = ({ payments, onConfirm, onCancel, onSuccess }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [processStatus, setProcessStatus] = useState(null);

  const formatCurrency = (value) => {
    const numValue = parseFloat(value);
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(numValue);
  };

  const getTotalAmount = () => {
    const total = payments.reduce((sum, payment) => {
      return sum + parseFloat(payment.E2_SALDO);
    }, 0);
    return formatCurrency(total);
  };

  const handleConfirmProcess = async () => {
    setIsProcessing(true);
    setProcessStatus({ processing: true, success: 0, failed: 0, total: payments.length });

    let successCount = 0;
    let failedCount = 0;

    for (const payment of payments) {
      try {
        console.log('Processing payment:', payment.E2_NUM);
        
        // Authorize payment by sending all parameters via query string
        const result = await authorizePayment(payment);
        
        console.log('Result received for payment:', payment.E2_NUM);
        console.log('Result object:', result);
        console.log('Result status:', result?.status);
        console.log('Result type:', typeof result);
        
        // Success if status is "PAYED"
        if (result && result.status === 'PAYED') {
          successCount++;
          console.log('Payment authorized successfully:', payment.E2_NUM);
        } else {
          failedCount++;
          console.error('Payment authorization failed:', payment.E2_NUM, 'Status:', result?.status);
        }

        setProcessStatus({
          processing: true,
          success: successCount,
          failed: failedCount,
          total: payments.length
        });
      } catch (error) {
        console.error('Error processing payment:', payment.E2_NUM, error);
        failedCount++;
        setProcessStatus({
          processing: true,
          success: successCount,
          failed: failedCount,
          total: payments.length
        });
      }
    }

    setIsProcessing(false);
    setProcessStatus({
      processing: false,
      success: successCount,
      failed: failedCount,
      total: payments.length
    });

    if (successCount > 0) {
      window.showAlert('success', `${successCount} pagamento(s) processado(s) com sucesso!`);
    }

    if (failedCount > 0) {
      window.showAlert('danger', `${failedCount} pagamento(s) falharam ao processar.`);
    }

    // Wait a moment before closing
    setTimeout(() => {
      if (onSuccess) {
        onSuccess();
      }
      onCancel();
    }, 1500);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container confirmation-modal">
        <h5>Aprovar Pagamentos</h5>
        
        {!processStatus && (
          <>
            <p className="confirmation-message">
              Tem certeza que deseja aprovar <strong>{payments.length}</strong> pagamento(s)?
            </p>
            
            <div className="payment-summary">
              <div className="summary-item">
                <span className="summary-label">Total de Pagamentos:</span>
                <span className="summary-value">{payments.length}</span>
              </div>
              <div className="summary-item">
                <span className="summary-label">Valor Total:</span>
                <span className="summary-value total-amount">{getTotalAmount()}</span>
              </div>
            </div>

            <div className="selected-payments-list">
              <h6>Pagamentos Selecionados:</h6>
              <div className="payments-list-content">
                {payments.map((payment, index) => (
                  <div key={index} className="payment-item">
                    <span className="payment-beneficiary">{payment.E2_NOMFOR}</span>
                    <span className="payment-amount">{formatCurrency(payment.E2_SALDO)}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="modal-actions">
              <button 
                className="btn btn-secondary" 
                onClick={onCancel}
                disabled={isProcessing}
              >
                Cancelar
              </button>
              <button 
                className="btn btn-success" 
                onClick={handleConfirmProcess}
                disabled={isProcessing}
              >
                Aprovar
              </button>
            </div>
          </>
        )}

        {processStatus && processStatus.processing && (
          <div className="processing-status">
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="visually-hidden">Processando...</span>
            </div>
            <p>Processando pagamentos...</p>
            <div className="progress-info">
              <p>Sucesso: <strong>{processStatus.success}</strong></p>
              <p>Falhou: <strong>{processStatus.failed}</strong></p>
              <p>Total: <strong>{processStatus.total}</strong></p>
            </div>
          </div>
        )}

        {processStatus && !processStatus.processing && (
          <div className="processing-complete">
            <i className="fas fa-check-circle text-success fa-3x mb-3"></i>
            <p>Processamento completo!</p>
            <div className="final-status">
              <p>Processados com sucesso: <strong className="text-success">{processStatus.success}</strong></p>
              {processStatus.failed > 0 && (
                <p>Falharam: <strong className="text-danger">{processStatus.failed}</strong></p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PixConfirmationPopup;
